import React, {CSSProperties, useState} from 'react'
import {
  AcrylicAlert,
  AcrylicTooltip,
  AcrylicPopover,
  AcrylicMenu,
  AcrylicDialog,
} from './acrylic-ui'

// --- 模拟图标 (由于移除了 mui icons，这里定义一些简单的占位符或文本) ---
const Icon = ({children}: {children: string}) => <span style={{marginRight: 8}}>{children}</span>
const CheckOutlinedIcon = () => <Icon>✅</Icon>
const ArchiveOutlinedIcon = () => <Icon>📦</Icon>
const DeleteForeverOutlinedIcon = () => <Icon>🗑️</Icon>
const BugReportOutlinedIcon = () => <Icon>🐛</Icon>
const FlagOutlinedIcon = () => <Icon>🚩</Icon>
const DraftsOutlinedIcon = () => <Icon>📧</Icon>
const PostAddIcon = () => <Icon>📝</Icon>

// --- 基础样式 ---
const acrylicStyle: CSSProperties = {
  backdropFilter: 'blur(30px) brightness(80%) saturate(160%)',
}

const gradientBg: React.CSSProperties = {
  backgroundImage: 'url(https://fdb.ubug.io/images/iPad%20Pro%202020%20Wallpaper%202%20YTECHB.jpg)',
  position: 'relative',
  backgroundSize: 'cover',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'stretch',
  justifyContent: 'center',
  backgroundPosition: '30%',
  // minHeight: '400px',
}

// 模拟 MUI Button 的基础样式
const BasicButton = (props: React.ButtonHTMLAttributes<HTMLButtonElement>) => (
  <button
    {...props}
    style={{
      padding: '8px 16px',
      cursor: 'pointer',
      backgroundColor: '#f5f5f5',
      color: '#333',
      border: '1px solid #ccc',
      borderRadius: '4px',
      ...props.style,
    }}
  />
)

const ExampleContainer: React.FC<{children: React.ReactNode}> = ({children}) => {
  return (
    <React.Fragment>
      <div style={gradientBg}>{children}</div>
      <style>{`
        @keyframes ani-bg-acrylic {
          0%{background-position:0% 50%}
          50%{background-position:100% 50%}
          100%{background-position:0% 50%}
        }
      `}</style>
    </React.Fragment>
  )
}

export const AcrylicDemo2 = () => {
  const [open, setOpen] = useState(false)
  const handleClick = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <ExampleContainer>
      <div style={{padding: '10px'}}>
        <BasicButton onClick={handleClick}>打开消息条</BasicButton>

        {open && (
          <div
            style={{
              position: 'fixed',
              bottom: 20,
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 1000,
            }}
          >
            <AcrylicAlert onClose={handleClose} variant="filled" severity="success">
              This is a success message!
            </AcrylicAlert>
          </div>
        )}

        {[
          {type: 'error', msg: 'This is an error message!'},
          {type: 'warning', msg: 'This is a warning message!'},
          {type: 'info', msg: 'This is an information message!'},
          {type: 'success', msg: 'This is a success message!'},
        ].map((item, idx) => (
          <div key={idx} style={{margin: '10px'}}>
            <AcrylicAlert variant="filled" severity={item.type as any}>
              {item.msg}
            </AcrylicAlert>
          </div>
        ))}
      </div>
    </ExampleContainer>
  )
}

export const AcrylicDemo3 = () => {
  const [open, setOpen] = useState(true)
  return (
    <ExampleContainer>
      <AcrylicTooltip
        open={open}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        title="一个标题栏、背景亚克力"
      >
        <BasicButton>你好，世界！</BasicButton>
      </AcrylicTooltip>
    </ExampleContainer>
  )
}

export const AcrylicDemo4 = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)
  const open = Boolean(anchorEl)

  return (
    <ExampleContainer>
      <BasicButton onClick={e => setAnchorEl(e.currentTarget)}>你好，世界！</BasicButton>
      <AcrylicPopover open={open} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
        <div style={{padding: '20px', width: '200px', textAlign: 'center'}}>
          <div style={{marginBottom: '20px', color: 'green', fontSize: '24px'}}>
            <CheckOutlinedIcon />
          </div>
          <BasicButton style={{width: '100%'}} onClick={() => setAnchorEl(null)}>
            OK
          </BasicButton>
        </div>
      </AcrylicPopover>
    </ExampleContainer>
  )
}

export const AcrylicDemo5 = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  return (
    <ExampleContainer>
      <BasicButton onClick={e => setAnchorEl(e.currentTarget)}>你好，世界！</BasicButton>
      <AcrylicMenu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <div style={{padding: '8px 0'}}>
          <div className="b-content-item" onClick={() => setAnchorEl(null)}>
            Profile
          </div>
          <div className="b-content-item" onClick={() => setAnchorEl(null)}>
            My account
          </div>
          <div className="b-content-item" onClick={() => setAnchorEl(null)}>
            Logout
          </div>
        </div>
      </AcrylicMenu>
    </ExampleContainer>
  )
}

export const AcrylicDemo6 = () => {
  const [open, setOpen] = useState(false)
  return (
    <ExampleContainer>
      <BasicButton onClick={() => setOpen(true)}>打开对话框</BasicButton>
      <AcrylicDialog open={open} onClose={() => setOpen(false)}>
        <div style={{padding: '20px'}}>
          <h3>Use Google's location service?</h3>
          <p>Let Google help apps determine location.</p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              marginTop: '20px',
            }}
          >
            <BasicButton onClick={() => setOpen(false)}>Disagree</BasicButton>
            <BasicButton
              onClick={() => setOpen(false)}
              style={{backgroundColor: '#1976d2', color: '#fff'}}
            >
              Agree
            </BasicButton>
          </div>
        </div>
      </AcrylicDialog>
    </ExampleContainer>
  )
}

// 模拟自定义 Slider
const CustomSlider = ({value, onChange, min = 0, max = 100, step = 1}: any) => (
  <input
    type="range"
    min={min}
    max={max}
    step={step}
    value={value}
    onChange={e => onChange(null, parseFloat(e.target.value))}
    style={{width: '100%', margin: '10px 0'}}
  />
)

export function AcrylicEffect() {
  const [blur, setBlur] = useState(30)
  const [brightness, setBrightness] = useState(120)
  const [color, setColor] = useState(50)
  const [colorOpacity, setColorOpacity] = useState(0.2)
  const [colorSaturate, setColorSaturate] = useState(80)
  const [noiseOpacity, setNoiseOpacity] = useState(0.8)
  const [noiseScale, setNoiseScale] = useState(30)

  return (
    <div style={{margin: '20px 0'}}>
      <div id="acrylic-demo-canvas">
        <div className="acrylic-demo acrylic-demo-1" style={{boxShadow: `0px 9px 20px #00000057`}}>
          <div className="gaussian-blur" style={{backdropFilter: `blur(${blur}px)`}}></div>
          <div
            className="luminosity-blend"
            style={{backdropFilter: `brightness(${brightness}%)`}}
          ></div>
          <div
            className="color-blend"
            style={{
              backdropFilter: `saturate(${colorSaturate}%)`,
              backgroundColor: `hsl(200, 50%, ${color}%)`,
              opacity: colorOpacity,
            }}
          ></div>
          <div
            className="noise-texture"
            style={{opacity: noiseOpacity, backgroundSize: `${noiseScale}px`}}
          ></div>
          <div className="a-content">Hello World</div>
        </div>
      </div>
      <div style={{width: '100%', padding: '20px', fontFamily: 'monospace'}}>
        blur: {blur}px; <CustomSlider value={blur} onChange={(_: any, v: number) => setBlur(v)} />
        brightness: {brightness}%{' '}
        <CustomSlider
          min={50}
          max={300}
          value={brightness}
          onChange={(_: any, v: number) => setBrightness(v)}
        />
        color:{' '}
        <span style={{background: `hsl(200, 50%, ${color}%)`, padding: '0 4px'}}>
          hsl({color}, 50%, 50%)
        </span>
        <CustomSlider
          min={0}
          max={100}
          value={color}
          onChange={(_: any, v: number) => setColor(v)}
        />
        color-saturate: {colorSaturate}%{' '}
        <CustomSlider
          min={50}
          max={300}
          value={colorSaturate}
          onChange={(_: any, v: number) => setColorSaturate(v)}
        />
        color-opacity: {colorOpacity}{' '}
        <CustomSlider
          step={0.05}
          min={0}
          max={1}
          value={colorOpacity}
          onChange={(_: any, v: number) => setColorOpacity(v)}
        />
        noise-opacity: {noiseOpacity}{' '}
        <CustomSlider
          step={0.05}
          min={0}
          max={1}
          value={noiseOpacity}
          onChange={(_: any, v: number) => setNoiseOpacity(v)}
        />
        noise-scale: {noiseScale}{' '}
        <CustomSlider
          min={10}
          max={500}
          value={noiseScale}
          onChange={(_: any, v: number) => setNoiseScale(v)}
        />
      </div>
    </div>
  )
}

export function AcrylicEffect2() {
  return (
    <div style={{background: '#eee', height: '500px', margin: '20px 0'}}>
      <div
        id="acrylic-demo-canvas"
        style={{
          backgroundImage: 'url(https://fdb.ubug.io/images/mail_transientcontextmenu-2.png)',
          height: '500px',
        }}
      >
        <div
          className="acrylic-demo acrylic-demo-2"
          style={{
            boxShadow: `0px 9px 20px #00000057`,
            backdropFilter: 'blur(30px) brightness(120%) saturate(160%)',
            backgroundColor: 'rgba(255,255,255,.6)',
            padding: '10px',
          }}
        >
          <div className="b-content">
            <div className="b-content-item">
              <BugReportOutlinedIcon /> CSS Effect
            </div>
            <div className="b-content-item">
              <ArchiveOutlinedIcon /> Archive
            </div>
            <div className="b-content-item">
              <DeleteForeverOutlinedIcon /> Delete
            </div>
            <div className="b-content-item">
              <PostAddIcon /> Move
            </div>
            <div className="b-content-item">
              <FlagOutlinedIcon /> Set Flag
            </div>
            <div className="b-content-item">
              <DraftsOutlinedIcon /> Mark as Read
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export function AcrylicEffect3() {
  return (
    <div style={{background: '#eee', height: '500px', width: '100%'}}>
      <div id="acrylic-demo-canvas" style={{height: '500px', margin: '0'}}>
        <div className="acrylic acrylic-demo-3">
          <div className="b-content">
            <div className="b-content-item">CSS Effect</div>
            <div className="b-content-item">Archive</div>
            <div className="b-content-item">Delete</div>
            <div className="b-content-item">Move</div>
            <div className="b-content-item">Set Flag</div>
            <div className="b-content-item">Mark as Read</div>
            <div className="b-content-item">Move to Junk</div>
            <div className="b-content-item">Move to Other</div>
            <div className="b-content-item">Always move to Other</div>
          </div>
        </div>
      </div>
      <style>
        {`.acrylic {
  /* size, position, etc... */
  position: relative;
  box-shadow: 0px 9px 20px #00000057;
  backdrop-filter:
      /* 负责背景模糊 */
      blur(30px)
      /* 负责亮度，100 以下会变暗，以上会提亮 */
      brightness(120%)
      /* 负责颜色饱和度，可以减小来衬托前景，避免背景太鲜艳 */
      saturate(80%);
  /* 负责颜色叠加，一半白色、黑色或主题色，衬托前景 */
  background-color: #ffffff88;
  /* 负责在效果上添加噪点，可以营造出磨砂效果 */
  background-size: 50px;
  background-image: url(data:image/png;base64,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);
}`}
      </style>
    </div>
  )
}

export const AcrylicEffectStyle = () => (
  <style>
    {`
      div#acrylic-demo-canvas {
        display: flex;
        padding: 40px 10px;
        align-items: center;
        justify-content: center;
        z-index: 10;
        margin: 20px 0;
        position: relative;
        background: url("https://fdb.ubug.io/images/background.jpg");
        background-size: cover;
        background-position: center;
      }
      .acrylic-demo {
        position: relative;
        width: 80%;
        height: 200px;
        box-shadow: 0px 9px 20px #00000057;
      }
      .acrylic-demo > div {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
      }
      .acrylic-demo-1 .luminosity-blend{ left: 20px; width: calc(100% - 20px); }
      .acrylic-demo-1 .color-blend{ left: 40px; width: calc(100% - 40px); }
      .acrylic-demo-1 .noise-texture, .acrylic-demo-1 .a-content { left: 60px; width: calc(100% - 60px); }

      .a-content { display: flex; align-items: center; justify-content: center; font-weight: bold; }

      .acrylic-demo-2 {
        position: absolute;
        top: 50%;
        left: 35%;
        transform: translate(-50%, -50%);
        width: auto;
        height: auto;
        animation: swing-acry 6s ease-in-out 0s infinite alternate;
      }
      @keyframes swing-acry { 0%{left: 25%;} 100%{left: 45%;} }
      
      .b-content-item {
        padding: 8px 12px;
        font-size: 14px;
        cursor: pointer;
        display: flex;
        align-items: center;
        color: #333;
        transition: background 0.2s;
      }
      .b-content-item:hover { background: rgba(33, 150, 243, 0.7); color: #fff; }
      
      .noise-texture {
        background-image: url(data:image/png;base64,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);
      }
    `}
  </style>
)
